
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/PrivacyStatement",
      function () {
        return require("private-next-pages/article/PrivacyStatement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/PrivacyStatement"])
      });
    }
  